export default __webpack_public_path__ + "static/media/google.debd6e93.svg";